import { Link } from '@tanstack/react-router'
import { Icone } from '../composants/Icone'

/** Adresse inconnue du routeur (lien ancien, adresse tapée à la main) : retour à l'accueil. */
export function Introuvable() {
  return (
    <div className="page-connexion">
      <main className="connexion">
        <span className="marque">
          <span className="marque-logo">
            <Icone nom="eco" plein taille={19} />
          </span>
          <span className="marque-texte">
            <strong>admin PMVB</strong>
            <span>Assistant administratif</span>
          </span>
        </span>
        <h1>Page introuvable</h1>
        <p className="discret">Cette adresse ne correspond à aucune page de l’application.</p>
        <Link to="/" className="bouton">
          Retour à l’accueil
        </Link>
      </main>
    </div>
  )
}
